import {
  Box,
  Container,
  Typography,
  Grid,
  Card,
  CardMedia,
  CardContent,
} from "@mui/material";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Navigation } from "swiper/modules";
import { ArrowLeft, ArrowRight } from "iconsax-react";

export default function EVShowcase({ com3struct }) {
  return (
    <Box>
      {com3struct.map((section, index) => {
        switch (section.type) {
          case "text":
            return (
              <>
                <Box
                  key={index}
                  sx={{
                    backgroundColor: section.backgroundColor,
                    color: section.color,
                    textAlign: "center",
                    py: 6,
                    px: 3,
                  }}
                >
                  <Container maxWidth="md">
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: "bold",
                        fontFamily: "KIAbodyLatinbasic_Bold",
                      }}
                      gutterBottom
                    >
                      {section.heading}
                    </Typography>
                    {section.description.map((line, i) => (
                      <Typography
                        key={i}
                        variant="body1"
                        sx={{
                          lineHeight: 1.6,
                          fontFamily: "KIAbodyLatinbasic_Regular",
                        }}
                      >
                        {line}
                      </Typography>
                    ))}
                  </Container>
                </Box>

                {section?.url && (
                  <Box
                    key={index}
                    sx={{
                      width: "100vw",
                      height: section.height,
                      overflow: "hidden",
                    }}
                  >
                    <Grid
                      container
                      sx={{
                        width: "100%",
                        height: section.height,
                        backgroundImage: `url(${section.url})`,
                        backgroundSize: "contain",
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat",
                      }}
                    />
                  </Box>
                )}
              </>
            );

          case "image":
            return (
              <>
                {section?.heading && (
                  <Box
                    key={index}
                    sx={{
                      backgroundColor: section?.backgroundColor,
                      color: section.color,
                      textAlign: "center",
                      py: 6,
                      px: 3,
                    }}
                  >
                    <Container maxWidth="md">
                      <Typography
                        variant="h3"
                        sx={{
                          fontWeight: "bold",
                          fontFamily: "KIAbodyLatinbasic_Bold",
                        }}
                        gutterBottom
                      >
                        {section?.heading}
                      </Typography>
                      {section?.description?.map((line, i) => (
                        <Typography
                          key={i}
                          variant="body1"
                          sx={{
                            lineHeight: 1.6,
                            fontFamily: "KIAbodyLatinbasic_Regular",
                          }}
                        >
                          {line}
                        </Typography>
                      ))}
                    </Container>
                  </Box>
                )}
                <Box
                  key={index}
                  sx={{
                    width: "100vw",
                    height: section.height,
                    overflow: "hidden",
                  }}
                >
                  <Grid
                    container
                    sx={{
                      width: "100%",
                      height: section.height,
                      backgroundImage: `url(${section.url})`,
                      backgroundSize: "contain",
                      backgroundPosition: "center",
                      backgroundRepeat: "no-repeat",
                    }}
                  />
                </Box>
              </>
            );

          case "cards":
            return (
              <Box
                key={index}
                sx={{
                  px: { xs: 2, sm: 4, md: 6 },
                  py: 6,
                  position: "relative",
                }}
              >
                {/* Custom Navigation Arrows */}
                <Box
                  className="swiper-button-prev-custom"
                  sx={{
                    position: "absolute",
                    top: "50%",
                    left: 30,
                    zIndex: 10,
                    transform: "translateY(-50%)",
                    cursor: "pointer",
                    background: "rgb(0, 0, 0, 0.3)",
                    color: "#fff",
                    padding: { xs: "10px", sm: "20px", md: "30px" },
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius: "50%",
                    "&:hover": {
                      background: "rgb(0, 0, 0)",
                    },
                  }}
                >
                  <ArrowLeft size={25} />
                </Box>

                <Box
                  className="swiper-button-next-custom"
                  sx={{
                    position: "absolute",
                    top: "50%",
                    right: 30,
                    zIndex: 10,
                    transform: "translateY(-50%)",
                    cursor: "pointer",
                    background: "rgb(0, 0, 0, 0.3)",
                    color: "#fff",
                    padding: { xs: "10px", sm: "20px", md: "30px" },
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius: "50%",
                    "&:hover": {
                      background: "rgb(0, 0, 0)",
                    },
                  }}
                >
                  <ArrowRight size={25} />
                </Box>

                <Swiper
                  modules={[Navigation]}
                  spaceBetween={30}
                  slidesPerView={3}
                  navigation={{
                    prevEl: ".swiper-button-prev-custom",
                    nextEl: ".swiper-button-next-custom",
                  }}
                  breakpoints={{
                    0: {
                      slidesPerView: 1,
                    },
                    600: {
                      slidesPerView: 1.5,
                    },
                    900: {
                      slidesPerView: 2,
                    },
                    1200: {
                      slidesPerView: 3,
                    },
                  }}
                  style={{ paddingBottom: "40px" }}
                >
                  {section.items.map((card, cardIndex) => (
                    <SwiperSlide key={cardIndex}>
                      <Card
                        sx={{
                          borderRadius: 0,
                          boxShadow: 0,
                          mx: "auto",
                          maxWidth: 350,
                        }}
                      >
                        <CardMedia
                          component="img"
                          loading="lazy"
                          image={card.image}
                          alt={card.title}
                          sx={{ height: 200, objectFit: "cover" }}
                        />
                        <CardContent>
                          <Typography
                            variant="h6"
                            sx={{
                              color: "#666666",
                              fontFamily: "KIAbodyLatinbasic_Bold",
                              mt: 2,
                              textAlign: "center",
                            }}
                          >
                            {card.title}
                          </Typography>
                          <Typography
                            sx={{
                              color: "#666666",
                              fontFamily: "KIAbodyLatinbasic_Regular",
                              mt: 1.5,
                              textAlign: "center",
                            }}
                          >
                            {card.description}
                          </Typography>
                        </CardContent>
                      </Card>
                    </SwiperSlide>
                  ))}
                </Swiper>
              </Box>
            );

          default:
            return null;
        }
      })}
    </Box>
  );
}
